// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-btn-wrapper{margin-top:1.5rem;margin-right:-.5rem}.badge{position:absolute;top:-5px;right:-5px;background-color:red;width:20px;height:20px;font-size:.8rem}.badge,.notification-btn{color:#fff;border-radius:50%}.notification-btn{background-color:#007bff;width:40px;height:35px;display:flex;justify-content:center;align-items:center;position:relative}", ""]);
// Exports
module.exports = exports;
